let isLoading = false;
const loadedResolves = [];
const loadedRejects = [];

// https://github.com/wan2land/vue-daum-postcode
function loadScript() {
  return new Promise((resolve, reject) => {
    if (window.daum && window.daum.postcode) {
      return resolve();
    }
    loadedResolves.push(resolve);
    loadedRejects.push(reject);
    if (isLoading) {
      return;
    }
    isLoading = true;

    const script = document.createElement('script');

    script.src = 'https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js';
    script.async = true;
    script.charset = 'utf8';

    const dom = document.head ||
      document.getElementsByTagName('head')[0] ||
      document.body ||
      document.getElementsByTagName('body')[0];

    dom.appendChild(script);

    script.onload = () => {
      isLoading = false;
      loadedResolves.forEach(cb => cb());
    };
    script.onerror = () => {
      isLoading = false;
      loadedRejects.forEach(cb => cb());
    };
  });
}

export default {
  props: {
    q: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    animation: {
      type: Boolean,
      default: false,
    },
    noAutoMapping: {
      type: Boolean,
      default: false,
    },
    noShorthand: {
      type: Boolean,
      default: false,
    },
    pleaseReadGuide: {
      type: Number,
      default: 0,
    },
    pleaseReadGuideTimer: {
      type: Number,
      default: 1.5,
    },
    maxSuggestItems: {
      type: Number,
      default: 10,
    },
    showMoreHName: {
      type: Boolean,
      default: false,
    },
    hideMapBtn: {
      type: Boolean,
      default: false,
    },
    hideEngBtn: {
      type: Boolean,
      default: false,
    },
    alwaysShowEngAddr: {
      type: Boolean,
      default: false,
    },
    zonecodeOnly: {
      type: Boolean,
      default: false,
    },
    theme: {
      type: Object,
      default: () => ({}),
    },
    height: {
      type: Number,
      default: 450,
    },
    fixedHeight: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      styleHeight: 0,
    };
  },
  watch: {
    q() {
      this.open();
    },
  },
  mounted() {
    loadScript().then(() => {
      return new Promise(resolve => window.daum.postcode.load(resolve));
    }).then(() => {
      this.daum = window.daum;
      this.open();
    });
  },
  computed: {
    styles() {
      const styles = { height: `${this.height}px` };
      if (!this.fixedHeight) {
        styles.height = this.styleHeight;
      }
      return styles;
    },
  },
  methods: {
    open() {
      new this.daum.Postcode({
        width: '100%',
        height: '100%',
        animation: this.animation,
        autoMapping: !this.noAutoMapping,
        shorthand: !this.noShorthand,
        pleaseReadGuide: this.pleaseReadGuide,
        pleaseReadGuideTimer: this.pleaseReadGuideTimer,
        maxSuggestItems: this.maxSuggestItems,
        showMoreHName: this.showMoreHName,
        hideMapBtn: this.hideMapBtn,
        hideEngBtn: this.hideEngBtn,
        alwaysShowEngAddr: this.alwaysShowEngAddr,
        zonecodeOnly: this.zonecodeOnly,
        theme: this.theme,
        oncomplete: (data) => {
          if (this.type !== '') data.type = this.type;
          this.$emit('complete', data);
        },
        onresize: (size) => {
          if (!this.fixedHeight) {
            this.styleHeight = `${size.height}px`;
          }
        },
      }).embed(this.$refs.container, {
        q: this.q,
        autoClose: true,
      });
    },
  },
  render(h) {
    return h('div', { class: ['vue-daum-postcode'] }, [
      h('div', { class: ['vue-daum-postcode-container'], ref: 'container', style: this.styles }),
    ]);
  },
};
